import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Colors, hexToRGB } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { formatDuration } from '../../../utils/duration-formatter';
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaDuration = ({
  media
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(StyledDuration, {
    children: formatDuration(media.duration, t)
  });
};
const StyledDuration = styled.span.withConfig({
  displayName: "MediaDuration__StyledDuration",
  componentId: "sc-toot7n-0"
})(["border-radius:4px;background-color:", ";padding:4px;display:block;", ";color:", ";text-align:center;"], hexToRGB(Colors.GREY_2a2a2a, 0.5), Fonts.medium(14), Colors.WHITE);